import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate, Link, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import axios from 'axios';

import speechStyles from './PostSpeech.module.css';
import audioStyles from './PostAudio.module.css';
import videoStyles from './PostVideo.module.css';
import ProdctionStyles from './PostProduction.module.css';

import speechIcon from '../../Assets/icons/icon2.png';
import audioIcon from '../../Assets/icons/icon3.png';
import videoIcon from '../../Assets/speeches/v1_83.png';

// const Post = () => {

//   const { year, slug, id } = useParams();
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [post, setPost] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [relatedPosts, setRelatedPosts] = useState([]);
//   const [isMediaLoading, setIsMediaLoading] = useState(true);
//   const [videoError, setVideoError] = useState(false);
//   const [retryCount, setRetryCount] = useState(0);

  
//   const videoRef = useRef(null);
//   const productionVideoRef = useRef(null);

//   const getMediaTypeFromPath = () => {
//     const path = location.pathname;
//     if (path.includes('/videos/')) return 'videos';
//     if (path.includes('/audios/')) return 'audios';
//     if (path.includes('/speeches/')) return 'speeches';
//     if (path.includes('/productions/')) return 'productions';
//     return 'speeches';
//   };

//   const getAPIConfig = (mediaType) => {
//     const configs = {
//       speeches: {
//         function: 'getSpeechByID',
//         routePrefix: 'speeches',
//         category: 'speech',
//         displayName: { fa: 'بيانات', ar: 'خطابات' }
//       },
//       videos: {
//         function: 'getVideoByID',
//         routePrefix: 'videos',
//         category: 'video',
//         displayName: { fa: 'ویدیویی', ar: 'فيديوهات' }
//       },
//       audios: {
//         function: 'getAudioByID',
//         routePrefix: 'audios',
//         category: 'audio',
//         displayName: { fa: 'صوتی', ar: 'صوتيات' }
//       },
//       productions: {
//         function: 'getProductionByID',
//         routePrefix: 'productions',
//         category: 'production',
//         displayName: { fa: 'توليدات', ar: 'إنتاجات' }
//       }
//     };
//     return configs[mediaType] || configs.speeches;
//   };

//   const currentMediaType = getMediaTypeFromPath();
//   const apiConfig = getAPIConfig(currentMediaType);
//   const helmetKey = `${currentMediaType}-${year}-${slug}-${id}`;
  
//   let lanuagePicked = localStorage.getItem('siteLanguage');
//   const isFa = lanuagePicked === 'fa';
//   let apiUrl = "";

//   // --- iOS Specific Helpers ---
//   const isIOS = () => {
//     return /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
//   };

//   // Simplified to apply to all iOS, as modern iOS also benefits from these attributes
//   const isAnyIOSDevice = isIOS();
  
//   const handleVideoError = (error, videoElement) => {
//     console.error('Video playback error:', error);
//     setVideoError(true);
//     setIsMediaLoading(false);

//     // Retry logic for all iOS devices, as it helps with various network/loading issues
//     if (isAnyIOSDevice && retryCount < 5) {
//       setTimeout(() => {
//         setRetryCount(prev => prev + 1);
//         setVideoError(false);
//         setIsMediaLoading(true);
//         if (videoElement) {
//           videoElement.load(); 
//           setTimeout(() => {
//             if (videoElement.readyState >= 2) {
//               videoElement.currentTime = 0;
//             }
//           }, 500);
//         }
//       }, 1500);
//     }
//   };

//   const handleVideoLoadStart = () => {
//     setIsMediaLoading(true);
//     setVideoError(false);
//   };

//   const handleVideoLoadedData = (videoElement) => {
//     setIsMediaLoading(false);
//     setVideoError(false);
//     // Ensure video is properly initialized for all iOS devices
//     if (isAnyIOSDevice && videoElement) {
//       videoElement.currentTime = 0;
//     }
//   };
  
//   const prepareVideoForIOS = (videoElement) => {
//     if (!videoElement || !isAnyIOSDevice) return;
    
//     videoElement.currentTime = 0;
    
//     videoElement.addEventListener('loadstart', () => console.log('Video load started'));
//     videoElement.addEventListener('loadedmetadata', () => {
//       console.log('Video metadata loaded');
//       if (videoElement.duration > 0) {
//         videoElement.currentTime = 0.1;
//         setTimeout(() => { videoElement.currentTime = 0; }, 100);
//       }
//     });
//     videoElement.addEventListener('canplay', () => {
//       console.log('Video can play');
//       setIsMediaLoading(false);
//       setVideoError(false);
//     });
//   };

//   useEffect(() => {
//     const fetchPost = async () => {
//       setLoading(true);
//       setError(null);
//       try {
//         if (isFa) {
//           apiUrl = `https://api.nasrollah.info/fa/?function=${apiConfig.function}&params=${id}`;
//         } else {
//           apiUrl = `https://api.nasrollah.info/ar/?function=${apiConfig.function}&params=${id}`;
//         }

//         const response = await axios.get(apiUrl, {
//           params: { slug: slug, include_related: true },
//           timeout: 15000,
//           headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
//         });

//         const postData = response.data;
//         if (postData.slug_post !== slug) console.warn('URL slug does not match post slug');
        
//         const expectedCategory = apiConfig.category;
//         if (postData.name_category?.toLowerCase() !== expectedCategory) {
//           console.warn(`Category mismatch: expected ${expectedCategory}, got ${postData.name_category}`);
//         }

//         setPost(postData);
//         if (postData.related_posts) setRelatedPosts(postData.related_posts.slice(0, 4));

//       } catch (err) {
//         console.error(`❌ Error fetching ${currentMediaType} post:`, err);
//         const errorMsg = isFa ? 'محتوا یافت نشد' : 'لم يتم العثور على المحتوى';
//         const genericError = isFa ? 'خطا در بارگذاری محتوا' : 'خطأ في تحميل المحتوى';
//         setError(err.response?.status === 404 ? errorMsg : genericError);
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (year && slug && id) {
//       fetchPost();
//     } else {
//       setError(isFa ? 'پارامترهای URL نامعتبر است' : 'معلمات URL غير صالحة');
//       setLoading(false);
//     }
//   }, [year, slug, id, currentMediaType, apiConfig.function, isFa]);

//   useEffect(() => {
//     if (post && (apiConfig.category === 'video' || apiConfig.category === 'production')) {
//       setTimeout(() => {
//         if (videoRef.current) prepareVideoForIOS(videoRef.current);
//         if (productionVideoRef.current) prepareVideoForIOS(productionVideoRef.current);
//       }, 100);
//     }
//   }, [post, apiConfig.category]);

//   useEffect(() => {
//     if (post?.title_post) {
//       document.title = `${post.title_post} - ${getCategoryDisplayName()}`;
//     }
//   }, [post, currentMediaType]);

//   useEffect(() => {
//     if (post) {
//       setTimeout(() => {
//         const setMeta = (name, content, isProperty = false) => {
//           const attr = isProperty ? 'property' : 'name';
//           const selector = `meta[${attr}="${name}"]`;
//           let meta = document.querySelector(selector);
//           if (!meta) {
//             meta = document.createElement('meta');
//             meta.setAttribute(attr, name);
//             document.head.appendChild(meta);
//           }
//           if (content) meta.setAttribute('content', content);
//         };

//         setMeta('description', post.meta_description_post || post.keywords_post || post.title_post);
//         setMeta('keywords', post.keywords_post);
//         setMeta('author', post.author_post);
//         setMeta('og:title', post.title_post, true);
//         setMeta('og:description', post.meta_description_post || post.keywords_post, true);
//       }, 100);
//     }
//   }, [post]);


//   const getStyles = () => {
//     switch(apiConfig.category) {
//       case 'speech': return speechStyles;
//       case 'audio': return audioStyles;
//       case 'video': return videoStyles;
//       case 'production': return ProdctionStyles;
//       default: return speechStyles;
//     }
//   };

//   const getDefaultIcon = () => {
//     switch(apiConfig.category) {
//       case 'speech': return speechIcon;
//       case 'audio': return audioIcon;
//       case 'video': return videoIcon;
//       default: return speechIcon;
//     }
//   };

//   const formatPersianDate = (dateString) => {
//     if (!dateString) return '';
//     try {
//       return new Intl.DateTimeFormat('fa-IR-u-ca-persian', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' }).format(new Date(dateString));
//     } catch (error) { return dateString; }
//   };
  
//   const formatArabicDate = (dateString) => {
//     if (!dateString) return '';
//     try {
//       return new Intl.DateTimeFormat('ar-EG', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' }).format(new Date(dateString));
//     } catch (error) { return dateString; }
//   };
  
//   const formatDate = (dateString) => {
//       return isFa ? formatPersianDate(dateString) : formatArabicDate(dateString);
//   };

//   const getCategoryDisplayName = () => {
//     return apiConfig.displayName[lanuagePicked] || apiConfig.displayName['fa'];
//   };

//   const getPremiumIcon = (type) => {
//   const icons = {
//     image: 'auto_awesome',
//     audio: 'graphic_eq',
//     video: 'movie',
//     production: 'movie_edit',
//     story: 'stars',
//     related: 'linked_services',
//     date: 'calendar_month',
//     author: 'person',
//     update: 'update',
//     error: 'error',
//     notFound: 'search_off',
//     published: 'verified',
//     pending: 'schedule',
//     back: 'arrow_back',
//     retry: 'refresh'
//   };

//   return icons[type] || icons.image;
// };

// const PremiumIcon = ({
//   type,
//   className = '',
//   filled = false,
//   label
// }) => {
//   return (
//     <span
//       className={`material-symbols-rounded ${className}`}
//       style={{
//         fontVariationSettings: `
//           'FILL' ${filled ? 1 : 0},
//           'wght' ${filled ? 600 : 500},
//           'GRAD' 0,
//           'opsz' 24
//         `
//       }}
//       aria-hidden={label ? undefined : 'true'}
//       aria-label={label}
//       role={label ? 'img' : undefined}
//     >
//       {getPremiumIcon(type)}
//     </span>
//   );
// };

//   const generateStructuredData = () => {
//     if (!post) return {};
//     const baseData = {
//       "@context": "https://schema.org",
//       "@type": apiConfig.category === 'video' ? "VideoObject" : "Article",
//       "headline": post.title_post,
//       "description": post.meta_description_post || post.keywords_post,
//       "datePublished": post.create_time_post,
//       "dateModified": post.original_time_post || post.create_time_post,
//       "author": { "@type": "Person", "name": post.author_post },
//       "url": `${window.location.origin}/${apiConfig.routePrefix}/${year}/${slug}/${id}`,
//     };
//     if (post.featured_media_post) {
//       if (apiConfig.category === 'video') {
//         baseData.contentUrl = post.featured_media_post;
//         baseData.embedUrl = post.featured_media_post;
//         baseData.thumbnailUrl = post.featured_post;
//       } else {
//         baseData.image = post.featured_media_post;
//       }
//     }
//     return baseData;
//   };

//   const styles = getStyles();

//   // --- Loading, Error, Not Found States ---
//   if (loading) {
//     return (
//       <div className={styles.loadingContainer}>
//         <div className={styles.loadingSpinner}></div>
//         <p className={styles.loadingText}>
//             {isFa ? `در حال بارگذاری ${getCategoryDisplayName()}...` : `جاري تحميل ${getCategoryDisplayName()}...`}
//         </p>
//       </div>
//     );
//   }

// if (error) {
//   return (
//     <>
//       <Helmet>
//         <title>
//           {isFa
//             ? `خطا در بارگذاری - ${error}`
//             : `خطأ في التحميل - ${error}`}
//         </title>

//         <meta name="robots" content="noindex" />
//       </Helmet>

//       <div className={styles.errorContainer}>
//         <div className={styles.errorIcon}>
//           <PremiumIcon type="error" filled />
//         </div>

//         <h1 className={styles.errorTitle}>
//           {isFa
//             ? `خطا در بارگذاری ${getCategoryDisplayName()}`
//             : `خطأ في تحميل ${getCategoryDisplayName()}`}
//         </h1>

//         <p className={styles.errorMessage}>{error}</p>

//         <div className={styles.errorActions}>
//           <button
//             type="button"
//             onClick={() => navigate(-1)}
//             className={styles.backButton}
//           >
//             <PremiumIcon type="back" />

//             <span>{isFa ? 'بازگشت' : 'رجوع'}</span>
//           </button>

//           <button
//             type="button"
//             onClick={() => window.location.reload()}
//             className={styles.retryButton}
//           >
//             <PremiumIcon type="retry" />

//             <span>{isFa ? 'تلاش مجدد' : 'إعادة المحاولة'}</span>
//           </button>
//         </div>
//       </div>
//     </>
//   );
// }

// if (!post) {
//   return (
//     <>
//       <Helmet>
//         <title>
//           {isFa
//             ? `${getCategoryDisplayName()} یافت نشد`
//             : `لم يتم العثور على ${getCategoryDisplayName()}`}
//         </title>

//         <meta name="robots" content="noindex" />
//       </Helmet>

//       <div className={styles.notFoundContainer}>
//         <div className={styles.notFoundIcon}>
//           <PremiumIcon type="notFound" filled />
//         </div>

//         <h1 className={styles.notFoundTitle}>
//           {isFa
//             ? `${getCategoryDisplayName()} یافت نشد`
//             : `لم يتم العثور على ${getCategoryDisplayName()}`}
//         </h1>

//         <p className={styles.notFoundMessage}>
//           {isFa
//             ? `متأسفانه ${getCategoryDisplayName()} درخواستی شما پیدا نشد.`
//             : `للأسف، لم يتم العثور على ${getCategoryDisplayName()} المطلوب.`}
//         </p>

//         <button
//           type="button"
//           onClick={() => navigate(-1)}
//           className={styles.backButton}
//         >
//           <PremiumIcon type="back" />

//           <span>{isFa ? 'بازگشت' : 'رجوع'}</span>
//         </button>
//       </div>
//     </>
//   );
// }

// // -------------------------------------------------------
// // Media renderer
// // -------------------------------------------------------

// const renderMedia = () => {
//   const category = apiConfig.category;

//   if (!post.featured_media_post) {
//     return (
//       <div className={styles.defaultMediaContainer}>
//         <img
//           src={getDefaultIcon()}
//           alt={
//             isFa
//               ? `آیکون ${getCategoryDisplayName()}`
//               : `أيقونة ${getCategoryDisplayName()}`
//           }
//           className={styles.defaultMediaIcon}
//           loading="lazy"
//         />
//       </div>
//     );
//   }

//   const mediaLoadingOverlay = isMediaLoading ? (
//     <div
//       className={styles.mediaLoadingOverlay}
//       role="status"
//       aria-label={isFa ? 'در حال بارگذاری رسانه' : 'جار تحميل الوسائط'}
//     >
//       <div className={styles.mediaLoadingSpinner} />
//     </div>
//   ) : null;

//   switch (category) {
//     case 'video':
//       return (
//         <div className={styles.videoContainer}>
//           <video
//             ref={videoRef}
//             controls
//             poster={post.media_post}
//             className={styles.videoPlayer}
//             controlsList="nodownload"
//             preload="metadata"
//             playsInline
//             webkit-playsinline="true"
//             x5-playsinline="true"
//             x5-video-player-type="h5"
//             x5-video-player-fullscreen="true"
//             onLoadStart={handleVideoLoadStart}
//             onLoadedData={() => handleVideoLoadedData(videoRef.current)}
//             onError={(event) =>
//               handleVideoError(event.target.error, videoRef.current)
//             }
//             autoPlay={false}
//             muted={false}
//           >
//             <source
//               src={post.featured_media_post}
//               type="video/mp4"
//             />

//             <source
//               src={post.featured_media_post.replace('.mp4', '.webm')}
//               type="video/webm"
//             />

//             <source
//               src={post.featured_media_post.replace('.mp4', '.ogg')}
//               type="video/ogg"
//             />

//             {isFa
//               ? 'مرورگر شما از پخش ویدیو پشتیبانی نمی‌کند.'
//               : 'متصفحك لا يدعم تشغيل الفيديو.'}
//           </video>

//           {mediaLoadingOverlay}
//         </div>
//       );

//     case 'production':
//       return (
//         <div className={ProdctionStyles.productionContainer}>
//           <video
//             ref={productionVideoRef}
//             controls
//             poster={post.media_post}
//             className={ProdctionStyles.productionPlayer}
//             controlsList="nodownload"
//             preload="metadata"
//             playsInline
//             webkit-playsinline="true"
//             x5-playsinline="true"
//             x5-video-player-type="h5"
//             x5-video-player-fullscreen="true"
//             onLoadStart={handleVideoLoadStart}
//             onLoadedData={() =>
//               handleVideoLoadedData(productionVideoRef.current)
//             }
//             onError={(event) =>
//               handleVideoError(
//                 event.target.error,
//                 productionVideoRef.current
//               )
//             }
//             autoPlay={false}
//             muted={false}
//           >
//             <source
//               src={post.featured_media_post}
//               type="video/mp4"
//             />

//             <source
//               src={post.featured_media_post.replace('.mp4', '.webm')}
//               type="video/webm"
//             />

//             <source
//               src={post.featured_media_post.replace('.mp4', '.ogg')}
//               type="video/ogg"
//             />

//             {isFa
//               ? 'مرورگر شما از پخش ویدیو پشتیبانی نمی‌کند.'
//               : 'متصفحك لا يدعم تشغيل الفيديو.'}
//           </video>

//           {mediaLoadingOverlay}
//         </div>
//       );

//     case 'audio':
//       return (
//         <div className={styles.audioContainer}>
//           <div className={styles.audioPlayer}>
//             <div className={styles.audioThumbnail}>
//               <img
//                 src={audioIcon}
//                 alt={isFa ? 'پخش صوتی' : 'ملف صوتي'}
//                 className={styles.audioIcon}
//               />
//             </div>

//             <audio
//               controls
//               className={styles.audioElement}
//               preload="metadata"
//               controlsList="nodownload"
//               onLoadStart={() => setIsMediaLoading(true)}
//               onLoadedData={() => setIsMediaLoading(false)}
//               onError={() => setIsMediaLoading(false)}
//             >
//               <source
//                 src={post.featured_media_post}
//                 type="audio/mp3"
//               />

//               <source
//                 src={post.featured_media_post}
//                 type="audio/mpeg"
//               />

//               <source
//                 src={post.featured_media_post.replace('.mp3', '.ogg')}
//                 type="audio/ogg"
//               />

//               <source
//                 src={post.featured_media_post.replace('.mp3', '.wav')}
//                 type="audio/wav"
//               />

//               {isFa
//                 ? 'مرورگر شما از پخش صوت پشتیبانی نمی‌کند.'
//                 : 'متصفحك لا يدعم تشغيل الصوت.'}
//             </audio>
//           </div>

//           {mediaLoadingOverlay}
//         </div>
//       );

//     default:
//       return (
//         <img
//           src={post.featured_media_post}
//           alt={
//             isFa
//               ? `تصویر ${getCategoryDisplayName()}`
//               : `صورة ${getCategoryDisplayName()}`
//           }
//           className={styles.speechesImage}
//           loading="lazy"
//           onError={(event) => {
//             event.currentTarget.src = getDefaultIcon();
//           }}
//         />
//       );
//   }
// };

// // -------------------------------------------------------
// // Related posts renderer
// // -------------------------------------------------------

// const renderRelatedPosts = () => {
//   if (relatedPosts.length === 0) {
//     return null;
//   }

//   return (
//     <section
//       className={styles.relatedPostsSection}
//       aria-labelledby="related-posts-title"
//     >
//       <h2
//         id="related-posts-title"
//         className={styles.relatedPostsTitle}
//       >
//         <PremiumIcon
//           type="related"
//           className={styles.relatedTitleIcon}
//           filled
//         />

//         <span>
//           {isFa ? 'محتوای مرتبط' : 'محتوى ذو صلة'}
//         </span>
//       </h2>

//       <div className={styles.relatedPostsGrid}>
//         {relatedPosts.map((relatedPost, index) => (
//           <Link
//             key={`${relatedPost.id_post}-${index}`}
//             to={`/${apiConfig.routePrefix}/${year}/${relatedPost.slug_post}/${relatedPost.id_post}`}
//             className={styles.relatedPostCard}
//             title={relatedPost.title_post}
//           >
//             <div className={styles.relatedPostImage}>
//               <img
//                 src={
//                   relatedPost.featured_media_post ||
//                   getDefaultIcon()
//                 }
//                 alt={relatedPost.title_post}
//                 loading="lazy"
//                 onError={(event) => {
//                   event.currentTarget.src = getDefaultIcon();
//                 }}
//               />
//             </div>

//             <div className={styles.relatedPostContent}>
//               <h3 className={styles.relatedPostTitle}>
//                 {relatedPost.title_post}
//               </h3>

//               <p className={styles.relatedPostDate}>
//                 <PremiumIcon
//                   type="date"
//                   className={styles.relatedDateIcon}
//                 />

//                 <span>
//                   {formatDate(relatedPost.create_time_post)}
//                 </span>
//               </p>
//             </div>
//           </Link>
//         ))}
//       </div>
//     </section>
//   );
// };

// // -------------------------------------------------------
// // SEO
// // -------------------------------------------------------

// const commonHelmet = (
//   <Helmet key={helmetKey}>
//     <title>
//       {post?.title_post
//         ? `${post.title_post} - ${getCategoryDisplayName()}`
//         : isFa
//           ? 'در حال بارگذاری...'
//           : 'جار التحميل...'}
//     </title>

//     {post?.meta_description_post && (
//       <meta
//         name="description"
//         content={post.meta_description_post}
//       />
//     )}

//     {post?.keywords_post && (
//       <meta
//         name="keywords"
//         content={post.keywords_post}
//       />
//     )}

//     {post?.author_post && (
//       <meta
//         name="author"
//         content={post.author_post}
//       />
//     )}

//     {post?.title_post && (
//       <meta
//         property="og:title"
//         content={post.title_post}
//       />
//     )}

//     {(post?.meta_description_post || post?.keywords_post) && (
//       <meta
//         property="og:description"
//         content={
//           post.meta_description_post ||
//           post.keywords_post
//         }
//       />
//     )}

//     <meta
//       property="og:type"
//       content={
//         apiConfig.category === 'video'
//           ? 'video.other'
//           : 'article'
//       }
//     />

//     <meta
//       property="og:url"
//       content={`${window.location.origin}/${apiConfig.routePrefix}/${year}/${slug}/${id}`}
//     />

//     {post?.featured_media_post && (
//       <meta
//         property="og:image"
//         content={post.featured_media_post}
//       />
//     )}

//     {post?.create_time_post && (
//       <meta
//         property="article:published_time"
//         content={post.create_time_post}
//       />
//     )}

//     {post?.author_post && (
//       <meta
//         property="article:author"
//         content={post.author_post}
//       />
//     )}

//     <link
//       rel="canonical"
//       href={`${window.location.origin}/${apiConfig.routePrefix}/${year}/${slug}/${id}`}
//     />

//     {post && (
//       <script type="application/ld+json">
//         {JSON.stringify(generateStructuredData())}
//       </script>
//     )}
//   </Helmet>
// );

// // -------------------------------------------------------
// // Persian section
// // -------------------------------------------------------

// if (isFa) {
//   return (
//     <>
//       {commonHelmet}

//       <article
//         className={`${styles.postContainer} ${styles.isPersian}`}
//         dir="rtl"
//       >
//         <div className={styles.postWrapper}>
//           <nav
//             className={styles.breadcrumb}
//             aria-label="مسیر صفحه"
//           >
//             <Link
//               to="/home"
//               className={styles.breadcrumbLink}
//             >
//               صفحه اصلی
//             </Link>

//             <span
//               className={styles.breadcrumbSeparator}
//               aria-hidden="true"
//             >
//               /
//             </span>

//             <Link
//               to={`/${apiConfig.routePrefix}`}
//               className={styles.breadcrumbLink}
//             >
//               {getCategoryDisplayName()}
//             </Link>

//             <span
//               className={styles.breadcrumbSeparator}
//               aria-hidden="true"
//             >
//               /
//             </span>

//             <Link
//               to={`/${apiConfig.routePrefix}/${year}`}
//               className={styles.breadcrumbLink}
//             >
//               سال {year}
//             </Link>

//             <span
//               className={styles.breadcrumbSeparator}
//               aria-hidden="true"
//             >
//               /
//             </span>

//             <span
//               className={styles.breadcrumbCurrent}
//               aria-current="page"
//             >
//               {post.title_post}
//             </span>
//           </nav>

//           <div className={styles.categoryBadge}>
//             <span className={styles.categoryIcon}>
//               <img
//                 src={getDefaultIcon()}
//                 alt=""
//                 aria-hidden="true"
//               />
//             </span>

//             <span className={styles.categoryText}>
//               {getCategoryDisplayName()}
//             </span>
//           </div>

//           <header className={styles.postHeader}>
//             <h1 className={styles.postTitle}>
//               {post.title_post}
//             </h1>
//           </header>

//           <div className={styles.postMeta}>
//             <div className={styles.metaItem}>
//               <span className={styles.metaIcon}>
//                 <PremiumIcon type="date" />
//               </span>

//               <time
//                 dateTime={post.create_time_post}
//                 className={styles.metaText}
//               >
//                 {formatDate(post.create_time_post)}
//               </time>
//             </div>

//             {post.author_post && (
//               <>
//                 <div
//                   className={styles.metaSeparator}
//                   aria-hidden="true"
//                 >
//                   •
//                 </div>

//                 <div className={styles.metaItem}>
//                   <span className={styles.metaIcon}>
//                     <PremiumIcon type="author" />
//                   </span>

//                   <span className={styles.metaText}>
//                     {post.author_post}
//                   </span>
//                 </div>
//               </>
//             )}

//             {post.original_time_post &&
//               post.original_time_post !== post.create_time_post && (
//                 <>
//                   <div
//                     className={styles.metaSeparator}
//                     aria-hidden="true"
//                   >
//                     •
//                   </div>

//                   <div className={styles.metaItem}>
//                     <span className={styles.metaIcon}>
//                       <PremiumIcon type="update" />
//                     </span>

//                     <time
//                       dateTime={post.original_time_post}
//                       className={styles.metaText}
//                       title="تاریخ بروزرسانی"
//                     >
//                       {formatDate(post.original_time_post)}
//                     </time>
//                   </div>
//                 </>
//               )}
//           </div>

//           <div className={styles.mediaSection}>
//             {renderMedia()}
//           </div>

//           <div className={styles.postContent}>
//             {post.html_post ? (
//               <div
//                 className={styles.contentHtml}
//                 dangerouslySetInnerHTML={{
//                   __html: post.html_post
//                 }}
//               />
//             ) : (
//               <div className={styles.contentText}>
//                 {post.keywords_post ||
//                   post.meta_description_post}
//               </div>
//             )}
//           </div>

//           <footer className={styles.postFooter}>
//             <div
//               className={`${styles.postStatus} ${
//                 post.status_post === 'published'
//                   ? styles.statusPublished
//                   : styles.statusPending
//               }`}
//             >
//               <span className={styles.statusIcon}>
//                 <PremiumIcon
//                   type={
//                     post.status_post === 'published'
//                       ? 'published'
//                       : 'pending'
//                   }
//                   filled={
//                     post.status_post === 'published'
//                   }
//                 />
//               </span>

//               <span className={styles.statusText}>
//                 {post.status_post === 'published'
//                   ? 'منتشر شده'
//                   : 'در انتظار انتشار'}
//               </span>
//             </div>

//             <div className={styles.navigationActions}>
//               <Link
//                 to={`/${apiConfig.routePrefix}/${year}`}
//                 className={styles.backToListButton}
//                 title={`بازگشت به لیست ${getCategoryDisplayName()} سال ${year}`}
//               >
//                 <PremiumIcon
//                   type="back"
//                   className={styles.backToListIcon}
//                 />

//                 <span>بازگشت به لیست</span>
//               </Link>
//             </div>
//           </footer>
//         </div>

//         {renderRelatedPosts()}
//       </article>
//     </>
//   );
// }

// // -------------------------------------------------------
// // Arabic section
// // -------------------------------------------------------

// return (
//   <>
//     {commonHelmet}

//     <article
//       className={`${styles.postContainer} ${styles.isArabic}`}
//       dir="rtl"
//     >
//       <div className={styles.postWrapper}>
//         <nav
//           className={styles.breadcrumb}
//           aria-label="مسار الصفحة"
//         >
//           <Link
//             to="/home"
//             className={styles.breadcrumbLink}
//           >
//             الرئيسية
//           </Link>

//           <span
//             className={styles.breadcrumbSeparator}
//             aria-hidden="true"
//           >
//             /
//           </span>

//           <Link
//             to={`/${apiConfig.routePrefix}`}
//             className={styles.breadcrumbLink}
//           >
//             {getCategoryDisplayName()}
//           </Link>

//           <span
//             className={styles.breadcrumbSeparator}
//             aria-hidden="true"
//           >
//             /
//           </span>

//           <Link
//             to={`/${apiConfig.routePrefix}/${year}`}
//             className={styles.breadcrumbLink}
//           >
//             سنة {year}
//           </Link>

//           <span
//             className={styles.breadcrumbSeparator}
//             aria-hidden="true"
//           >
//             /
//           </span>

//           <span
//             className={styles.breadcrumbCurrent}
//             aria-current="page"
//           >
//             {post.title_post}
//           </span>
//         </nav>

//         <div className={styles.categoryBadge}>
//           <span className={styles.categoryIcon}>
//             <img
//               src={getDefaultIcon()}
//               alt=""
//               aria-hidden="true"
//             />
//           </span>

//           <span className={styles.categoryText}>
//             {getCategoryDisplayName()}
//           </span>
//         </div>

//         <header className={styles.postHeader}>
//           <h1 className={styles.postTitle}>
//             {post.title_post}
//           </h1>
//         </header>

//         <div className={styles.postMeta}>
//           <div className={styles.metaItem}>
//             <span className={styles.metaIcon}>
//               <PremiumIcon type="date" />
//             </span>

//             <time
//               dateTime={post.create_time_post}
//               className={styles.metaText}
//             >
//               {formatDate(post.create_time_post)}
//             </time>
//           </div>

//           {post.author_post && (
//             <>
//               <div
//                 className={styles.metaSeparator}
//                 aria-hidden="true"
//               >
//                 •
//               </div>

//               <div className={styles.metaItem}>
//                 <span className={styles.metaIcon}>
//                   <PremiumIcon type="author" />
//                 </span>

//                 <span className={styles.metaText}>
//                   {post.author_post}
//                 </span>
//               </div>
//             </>
//           )}

//           {post.original_time_post &&
//             post.original_time_post !== post.create_time_post && (
//               <>
//                 <div
//                   className={styles.metaSeparator}
//                   aria-hidden="true"
//                 >
//                   •
//                 </div>

//                 <div className={styles.metaItem}>
//                   <span className={styles.metaIcon}>
//                     <PremiumIcon type="update" />
//                   </span>

//                   <time
//                     dateTime={post.original_time_post}
//                     className={styles.metaText}
//                     title="تاريخ التحديث"
//                   >
//                     {formatDate(post.original_time_post)}
//                   </time>
//                 </div>
//               </>
//             )}
//         </div>

//         <div className={styles.mediaSection}>
//           {renderMedia()}
//         </div>

//         <div className={styles.postContent}>
//           {post.html_post ? (
//             <div
//               className={styles.contentHtml}
//               dangerouslySetInnerHTML={{
//                 __html: post.html_post
//               }}
//             />
//           ) : (
//             <div className={styles.contentText}>
//               {post.keywords_post ||
//                 post.meta_description_post}
//             </div>
//           )}
//         </div>

//         <footer className={styles.postFooter}>
//           <div
//             className={`${styles.postStatus} ${
//               post.status_post === 'published'
//                 ? styles.statusPublished
//                 : styles.statusPending
//             }`}
//           >
//             <span className={styles.statusIcon}>
//               <PremiumIcon
//                 type={
//                   post.status_post === 'published'
//                     ? 'published'
//                     : 'pending'
//                 }
//                 filled={
//                   post.status_post === 'published'
//                 }
//               />
//             </span>

//             <span className={styles.statusText}>
//               {post.status_post === 'published'
//                 ? 'منشور'
//                 : 'منتظر النشر'}
//             </span>
//           </div>

//           <div className={styles.navigationActions}>
//             <Link
//               to={`/${apiConfig.routePrefix}/${year}`}
//               className={styles.backToListButton}
//               title={`العودة إلى قائمة ${getCategoryDisplayName()} سنة ${year}`}
//             >
//               <PremiumIcon
//                 type="back"
//                 className={styles.backToListIcon}
//               />

//               <span>العودة إلى القائمة</span>
//             </Link>
//           </div>
//         </footer>
//       </div>

//       {renderRelatedPosts()}
//     </article>
//   </>
// );
// };

// export default Post;


const Post = () => {

  const { year, slug, id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [relatedPosts, setRelatedPosts] = useState([]);
  const [isMediaLoading, setIsMediaLoading] = useState(true);
  const [videoError, setVideoError] = useState(false);
  const [retryCount, setRetryCount] = useState(0);

  
  const videoRef = useRef(null);
  const productionVideoRef = useRef(null);

  const getMediaTypeFromPath = () => {
    const path = location.pathname;
    if (path.includes('/videos/')) return 'videos';
    if (path.includes('/audios/')) return 'audios';
    if (path.includes('/speeches/')) return 'speeches';
    if (path.includes('/productions/')) return 'productions';
    return 'speeches';
  };

  const getAPIConfig = (mediaType) => {
    const configs = {
      speeches: {
        function: 'getSpeechByID',
        routePrefix: 'speeches',
        category: 'speech',
        displayName: { fa: 'بيانات', ar: 'خطابات' }
      },
      videos: {
        function: 'getVideoByID',
        routePrefix: 'videos',
        category: 'video',
        displayName: { fa: 'ویدیویی', ar: 'فيديوهات' }
      },
      audios: {
        function: 'getAudioByID',
        routePrefix: 'audios',
        category: 'audio',
        displayName: { fa: 'صوتی', ar: 'صوتيات' }
      },
      productions: {
        function: 'getProductionByID',
        routePrefix: 'productions',
        category: 'production',
        displayName: { fa: 'توليدات', ar: 'إنتاجات' }
      }
    };
    return configs[mediaType] || configs.speeches;
  };

  const currentMediaType = getMediaTypeFromPath();
  const apiConfig = getAPIConfig(currentMediaType);
  const helmetKey = `${currentMediaType}-${year}-${slug}-${id}`;
  
  let lanuagePicked = localStorage.getItem('siteLanguage');
  const isFa = lanuagePicked === 'fa';
  let apiUrl = "";

  // --- iOS Specific Helpers ---
  const isIOS = () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  };

  // Simplified to apply to all iOS, as modern iOS also benefits from these attributes
  const isAnyIOSDevice = isIOS();
  
  const handleVideoError = (error, videoElement) => {
    console.error('Video playback error:', error);
    setVideoError(true);
    setIsMediaLoading(false);

    // Retry logic for all iOS devices, as it helps with various network/loading issues
    if (isAnyIOSDevice && retryCount < 5) {
      setTimeout(() => {
        setRetryCount(prev => prev + 1);
        setVideoError(false);
        setIsMediaLoading(true);
        if (videoElement) {
          videoElement.load(); 
          setTimeout(() => {
            if (videoElement.readyState >= 2) {
              videoElement.currentTime = 0;
            }
          }, 500);
        }
      }, 1500);
    }
  };

  const handleVideoLoadStart = () => {
    setIsMediaLoading(true);
    setVideoError(false);
  };

  const handleVideoLoadedData = (videoElement) => {
    setIsMediaLoading(false);
    setVideoError(false);
    // Ensure video is properly initialized for all iOS devices
    if (isAnyIOSDevice && videoElement) {
      videoElement.currentTime = 0;
    }
  };
  
  const prepareVideoForIOS = (videoElement) => {
    if (!videoElement || !isAnyIOSDevice) return;
    
    videoElement.currentTime = 0;
    
    videoElement.addEventListener('loadstart', () => console.log('Video load started'));
    videoElement.addEventListener('loadedmetadata', () => {
      console.log('Video metadata loaded');
      if (videoElement.duration > 0) {
        videoElement.currentTime = 0.1;
        setTimeout(() => { videoElement.currentTime = 0; }, 100);
      }
    });
    videoElement.addEventListener('canplay', () => {
      console.log('Video can play');
      setIsMediaLoading(false);
      setVideoError(false);
    });
  };

  useEffect(() => {
    const fetchPost = async () => {
      setLoading(true);
      setError(null);
      try {
        if (isFa) {
          apiUrl = `https://api.nasrollah.info/fa/?function=${apiConfig.function}&params=${id}`;
        } else {
          apiUrl = `https://api.nasrollah.info/ar/?function=${apiConfig.function}&params=${id}`;
        }

        const response = await axios.get(apiUrl, {
          params: { slug: slug, include_related: true },
          timeout: 15000,
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
        });

        const postData = response.data;
        if (postData.slug_post !== slug) console.warn('URL slug does not match post slug');
        
        const expectedCategory = apiConfig.category;
        if (postData.name_category?.toLowerCase() !== expectedCategory) {
          console.warn(`Category mismatch: expected ${expectedCategory}, got ${postData.name_category}`);
        }

        setPost(postData);
        if (postData.related_posts) setRelatedPosts(postData.related_posts.slice(0, 4));

      } catch (err) {
        console.error(`❌ Error fetching ${currentMediaType} post:`, err);
        const errorMsg = isFa ? 'محتوا یافت نشد' : 'لم يتم العثور على المحتوى';
        const genericError = isFa ? 'خطا در بارگذاری محتوا' : 'خطأ في تحميل المحتوى';
        setError(err.response?.status === 404 ? errorMsg : genericError);
      } finally {
        setLoading(false);
      }
    };

    if (year && slug && id) {
      fetchPost();
    } else {
      setError(isFa ? 'پارامترهای URL نامعتبر است' : 'معلمات URL غير صالحة');
      setLoading(false);
    }
  }, [year, slug, id, currentMediaType, apiConfig.function, isFa]);

  useEffect(() => {
    if (post && (apiConfig.category === 'video' || apiConfig.category === 'production')) {
      setTimeout(() => {
        if (videoRef.current) prepareVideoForIOS(videoRef.current);
        if (productionVideoRef.current) prepareVideoForIOS(productionVideoRef.current);
      }, 100);
    }
  }, [post, apiConfig.category]);

  useEffect(() => {
    if (post?.title_post) {
      document.title = `${post.title_post} - ${getCategoryDisplayName()}`;
    }
  }, [post, currentMediaType]);

  useEffect(() => {
    if (post) {
      setTimeout(() => {
        const setMeta = (name, content, isProperty = false) => {
          const attr = isProperty ? 'property' : 'name';
          const selector = `meta[${attr}="${name}"]`;
          let meta = document.querySelector(selector);
          if (!meta) {
            meta = document.createElement('meta');
            meta.setAttribute(attr, name);
            document.head.appendChild(meta);
          }
          if (content) meta.setAttribute('content', content);
        };

        setMeta('description', post.meta_description_post || post.keywords_post || post.title_post);
        setMeta('keywords', post.keywords_post);
        setMeta('author', post.author_post);
        setMeta('og:title', post.title_post, true);
        setMeta('og:description', post.meta_description_post || post.keywords_post, true);
      }, 100);
    }
  }, [post]);


  const getStyles = () => {
    switch(apiConfig.category) {
      case 'speech': return speechStyles;
      case 'audio': return audioStyles;
      case 'video': return videoStyles;
      case 'production': return ProdctionStyles;
      default: return speechStyles;
    }
  };

  const getDefaultIcon = () => {
    switch(apiConfig.category) {
      case 'speech': return speechIcon;
      case 'audio': return audioIcon;
      case 'video': return videoIcon;
      default: return speechIcon;
    }
  };

  const formatPersianDate = (dateString) => {
    if (!dateString) return '';
    try {
      return new Intl.DateTimeFormat('fa-IR-u-ca-persian', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' }).format(new Date(dateString));
    } catch (error) { return dateString; }
  };
  
  const formatArabicDate = (dateString) => {
    if (!dateString) return '';
    try {
      return new Intl.DateTimeFormat('ar-EG', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' }).format(new Date(dateString));
    } catch (error) { return dateString; }
  };
  
  const formatDate = (dateString) => {
      return isFa ? formatPersianDate(dateString) : formatArabicDate(dateString);
  };

  const getCategoryDisplayName = () => {
    return apiConfig.displayName[lanuagePicked] || apiConfig.displayName['fa'];
  };

  const getPremiumIcon = (type) => {
  const icons = {
    image: 'auto_awesome',
    audio: 'graphic_eq',
    video: 'movie',
    production: 'movie_edit',
    story: 'stars',
    related: 'linked_services',
    date: 'calendar_month',
    author: 'person',
    update: 'update',
    error: 'error',
    notFound: 'search_off',
    published: 'verified',
    pending: 'schedule',
    back: 'arrow_back',
    retry: 'refresh'
  };

  return icons[type] || icons.image;
};

const PremiumIcon = ({
  type,
  className = '',
  filled = false,
  label
}) => {
  return (
    <span
      className={`material-symbols-outlined ${className}`}
      style={{
        fontVariationSettings: `
          'FILL' ${filled ? 1 : 0},
          'wght' ${filled ? 600 : 500},
          'GRAD' 0,
          'opsz' 24
        `
      }}
      aria-hidden={label ? undefined : 'true'}
      aria-label={label}
      role={label ? 'img' : undefined}
    >
      {getPremiumIcon(type)}
    </span>
  );
};

  const generateStructuredData = () => {
    if (!post) return {};
    const baseData = {
      "@context": "https://schema.org",
      "@type": apiConfig.category === 'video' ? "VideoObject" : "Article",
      "headline": post.title_post,
      "description": post.meta_description_post || post.keywords_post,
      "datePublished": post.create_time_post,
      "dateModified": post.original_time_post || post.create_time_post,
      "author": { "@type": "Person", "name": post.author_post },
      "url": `${window.location.origin}/${apiConfig.routePrefix}/${year}/${slug}/${id}`,
    };
    if (post.featured_media_post) {
      if (apiConfig.category === 'video') {
        baseData.contentUrl = post.featured_media_post;
        baseData.embedUrl = post.featured_media_post;
        baseData.thumbnailUrl = post.featured_post;
      } else {
        baseData.image = post.featured_media_post;
      }
    }
    return baseData;
  };

  const styles = getStyles();

  // --- Loading, Error, Not Found States ---
  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.loadingSpinner}></div>
        <p className={styles.loadingText}>
            {isFa ? `در حال بارگذاری ${getCategoryDisplayName()}...` : `جاري تحميل ${getCategoryDisplayName()}...`}
        </p>
      </div>
    );
  }

if (error) {
  return (
    <>
      <Helmet>
        <title>
          {isFa
            ? `خطا در بارگذاری - ${error}`
            : `خطأ في التحميل - ${error}`}
        </title>

        <meta name="robots" content="noindex" />
      </Helmet>

      <div className={styles.errorContainer}>
        <div className={styles.errorIcon}>
          <PremiumIcon type="error" filled />
        </div>

        <h1 className={styles.errorTitle}>
          {isFa
            ? `خطا در بارگذاری ${getCategoryDisplayName()}`
            : `خطأ في تحميل ${getCategoryDisplayName()}`}
        </h1>

        <p className={styles.errorMessage}>{error}</p>

        <div className={styles.errorActions}>
          <button
            type="button"
            onClick={() => navigate(-1)}
            className={styles.backButton}
          >
            <PremiumIcon type="back" />

            <span>{isFa ? 'بازگشت' : 'رجوع'}</span>
          </button>

          <button
            type="button"
            onClick={() => window.location.reload()}
            className={styles.retryButton}
          >
            <PremiumIcon type="retry" />

            <span>{isFa ? 'تلاش مجدد' : 'إعادة المحاولة'}</span>
          </button>
        </div>
      </div>
    </>
  );
}

if (!post) {
  return (
    <>
      <Helmet>
        <title>
          {isFa
            ? `${getCategoryDisplayName()} یافت نشد`
            : `لم يتم العثور على ${getCategoryDisplayName()}`}
        </title>

        <meta name="robots" content="noindex" />
      </Helmet>

      <div className={styles.notFoundContainer}>
        <div className={styles.notFoundIcon}>
          <PremiumIcon type="notFound" filled />
        </div>

        <h1 className={styles.notFoundTitle}>
          {isFa
            ? `${getCategoryDisplayName()} یافت نشد`
            : `لم يتم العثور على ${getCategoryDisplayName()}`}
        </h1>

        <p className={styles.notFoundMessage}>
          {isFa
            ? `متأسفانه ${getCategoryDisplayName()} درخواستی شما پیدا نشد.`
            : `للأسف، لم يتم العثور على ${getCategoryDisplayName()} المطلوب.`}
        </p>

        <button
          type="button"
          onClick={() => navigate(-1)}
          className={styles.backButton}
        >
          <PremiumIcon type="back" />

          <span>{isFa ? 'بازگشت' : 'رجوع'}</span>
        </button>
      </div>
    </>
  );
}

// -------------------------------------------------------
// Media renderer
// -------------------------------------------------------

const renderMedia = () => {
  const category = apiConfig.category;

  if (!post.featured_media_post) {
    return (
      <div className={styles.defaultMediaContainer}>
        <img
          src={getDefaultIcon()}
          alt={
            isFa
              ? `آیکون ${getCategoryDisplayName()}`
              : `أيقونة ${getCategoryDisplayName()}`
          }
          className={styles.defaultMediaIcon}
          loading="lazy"
        />
      </div>
    );
  }

  const mediaLoadingOverlay = isMediaLoading ? (
    <div
      className={styles.mediaLoadingOverlay}
      role="status"
      aria-label={isFa ? 'در حال بارگذاری رسانه' : 'جار تحميل الوسائط'}
    >
      <div className={styles.mediaLoadingSpinner} />
    </div>
  ) : null;

  switch (category) {
    case 'video':
      return (
        <div className={styles.videoContainer}>
          <video
            ref={videoRef}
            controls
            poster={post.media_post}
            className={styles.videoPlayer}
            controlsList="nodownload"
            preload="metadata"
            playsInline
            webkit-playsinline="true"
            x5-playsinline="true"
            x5-video-player-type="h5"
            x5-video-player-fullscreen="true"
            onLoadStart={handleVideoLoadStart}
            onLoadedData={() => handleVideoLoadedData(videoRef.current)}
            onError={(event) =>
              handleVideoError(event.target.error, videoRef.current)
            }
            autoPlay={false}
            muted={false}
          >
            <source
              src={post.featured_media_post}
              type="video/mp4"
            />

            <source
              src={post.featured_media_post.replace('.mp4', '.webm')}
              type="video/webm"
            />

            <source
              src={post.featured_media_post.replace('.mp4', '.ogg')}
              type="video/ogg"
            />

            {isFa
              ? 'مرورگر شما از پخش ویدیو پشتیبانی نمی‌کند.'
              : 'متصفحك لا يدعم تشغيل الفيديو.'}
          </video>

          {mediaLoadingOverlay}
        </div>
      );

    case 'production':
      return (
        <div className={ProdctionStyles.productionContainer}>
          <video
            ref={productionVideoRef}
            controls
            poster={post.media_post}
            className={ProdctionStyles.productionPlayer}
            controlsList="nodownload"
            preload="metadata"
            playsInline
            webkit-playsinline="true"
            x5-playsinline="true"
            x5-video-player-type="h5"
            x5-video-player-fullscreen="true"
            onLoadStart={handleVideoLoadStart}
            onLoadedData={() =>
              handleVideoLoadedData(productionVideoRef.current)
            }
            onError={(event) =>
              handleVideoError(
                event.target.error,
                productionVideoRef.current
              )
            }
            autoPlay={false}
            muted={false}
          >
            <source
              src={post.featured_media_post}
              type="video/mp4"
            />

            <source
              src={post.featured_media_post.replace('.mp4', '.webm')}
              type="video/webm"
            />

            <source
              src={post.featured_media_post.replace('.mp4', '.ogg')}
              type="video/ogg"
            />

            {isFa
              ? 'مرورگر شما از پخش ویدیو پشتیبانی نمی‌کند.'
              : 'متصفحك لا يدعم تشغيل الفيديو.'}
          </video>

          {mediaLoadingOverlay}
        </div>
      );

    case 'audio':
      return (
        <div className={styles.audioContainer}>
          <div className={styles.audioPlayer}>
            <div className={styles.audioThumbnail}>
              <img
                src={audioIcon}
                alt={isFa ? 'پخش صوتی' : 'ملف صوتي'}
                className={styles.audioIcon}
              />
            </div>

            <audio
              controls
              className={styles.audioElement}
              preload="metadata"
              controlsList="nodownload"
              onLoadStart={() => setIsMediaLoading(true)}
              onLoadedData={() => setIsMediaLoading(false)}
              onError={() => setIsMediaLoading(false)}
            >
              <source
                src={post.featured_media_post}
                type="audio/mp3"
              />

              <source
                src={post.featured_media_post}
                type="audio/mpeg"
              />

              <source
                src={post.featured_media_post.replace('.mp3', '.ogg')}
                type="audio/ogg"
              />

              <source
                src={post.featured_media_post.replace('.mp3', '.wav')}
                type="audio/wav"
              />

              {isFa
                ? 'مرورگر شما از پخش صوت پشتیبانی نمی‌کند.'
                : 'متصفحك لا يدعم تشغيل الصوت.'}
            </audio>
          </div>

          {mediaLoadingOverlay}
        </div>
      );

    default:
      return (
        <img
          src={post.featured_media_post}
          alt={
            isFa
              ? `تصویر ${getCategoryDisplayName()}`
              : `صورة ${getCategoryDisplayName()}`
          }
          className={styles.speechesImage}
          loading="lazy"
          onError={(event) => {
            event.currentTarget.src = getDefaultIcon();
          }}
        />
      );
  }
};

// -------------------------------------------------------
// Related posts renderer
// -------------------------------------------------------

const renderRelatedPosts = () => {
  if (relatedPosts.length === 0) {
    return null;
  }

  return (
    <section
      className={styles.relatedPostsSection}
      aria-labelledby="related-posts-title"
    >
      <h2
        id="related-posts-title"
        className={styles.relatedPostsTitle}
      >
        <PremiumIcon
          type="related"
          className={styles.relatedTitleIcon}
          filled
        />

        <span>
          {isFa ? 'محتوای مرتبط' : 'محتوى ذو صلة'}
        </span>
      </h2>

      <div className={styles.relatedPostsGrid}>
        {relatedPosts.map((relatedPost, index) => (
          <Link
            key={`${relatedPost.id_post}-${index}`}
            to={`/${apiConfig.routePrefix}/${year}/${relatedPost.slug_post}/${relatedPost.id_post}`}
            className={styles.relatedPostCard}
            title={relatedPost.title_post}
          >
            <div className={styles.relatedPostImage}>
              <img
                src={
                  relatedPost.featured_media_post ||
                  getDefaultIcon()
                }
                alt={relatedPost.title_post}
                loading="lazy"
                onError={(event) => {
                  event.currentTarget.src = getDefaultIcon();
                }}
              />
            </div>

            <div className={styles.relatedPostContent}>
              <h3 className={styles.relatedPostTitle}>
                {relatedPost.title_post}
              </h3>

              <p className={styles.relatedPostDate}>
                <PremiumIcon
                  type="date"
                  className={styles.relatedDateIcon}
                />

                <span>
                  {formatDate(relatedPost.create_time_post)}
                </span>
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

// -------------------------------------------------------
// SEO
// -------------------------------------------------------

const commonHelmet = (
  <Helmet key={helmetKey}>
    <title>
      {post?.title_post
        ? `${post.title_post} - ${getCategoryDisplayName()}`
        : isFa
          ? 'در حال بارگذاری...'
          : 'جار التحميل...'}
    </title>

    {post?.meta_description_post && (
      <meta
        name="description"
        content={post.meta_description_post}
      />
    )}

    {post?.keywords_post && (
      <meta
        name="keywords"
        content={post.keywords_post}
      />
    )}

    {post?.author_post && (
      <meta
        name="author"
        content={post.author_post}
      />
    )}

    {post?.title_post && (
      <meta
        property="og:title"
        content={post.title_post}
      />
    )}

    {(post?.meta_description_post || post?.keywords_post) && (
      <meta
        property="og:description"
        content={
          post.meta_description_post ||
          post.keywords_post
        }
      />
    )}

    <meta
      property="og:type"
      content={
        apiConfig.category === 'video'
          ? 'video.other'
          : 'article'
      }
    />

    <meta
      property="og:url"
      content={`${window.location.origin}/${apiConfig.routePrefix}/${year}/${slug}/${id}`}
    />

    {post?.featured_media_post && (
      <meta
        property="og:image"
        content={post.featured_media_post}
      />
    )}

    {post?.create_time_post && (
      <meta
        property="article:published_time"
        content={post.create_time_post}
      />
    )}

    {post?.author_post && (
      <meta
        property="article:author"
        content={post.author_post}
      />
    )}

    <link
      rel="canonical"
      href={`${window.location.origin}/${apiConfig.routePrefix}/${year}/${slug}/${id}`}
    />

    {post && (
      <script type="application/ld+json">
        {JSON.stringify(generateStructuredData())}
      </script>
    )}
  </Helmet>
);

// -------------------------------------------------------
// Persian section
// -------------------------------------------------------

if (isFa) {
  return (
    <>
      {commonHelmet}

      <article
        className={`${styles.postContainer} ${styles.isPersian}`}
        dir="rtl"
      >
        <div className={styles.postWrapper}>
          <nav
            className={styles.breadcrumb}
            aria-label="مسیر صفحه"
          >
            <Link
              to="/home"
              className={styles.breadcrumbLink}
            >
              صفحه اصلی
            </Link>

            <span
              className={styles.breadcrumbSeparator}
              aria-hidden="true"
            >
              /
            </span>

            <Link
              to={`/${apiConfig.routePrefix}`}
              className={styles.breadcrumbLink}
            >
              {getCategoryDisplayName()}
            </Link>

            <span
              className={styles.breadcrumbSeparator}
              aria-hidden="true"
            >
              /
            </span>

            <Link
              to={`/${apiConfig.routePrefix}/${year}`}
              className={styles.breadcrumbLink}
            >
              سال {year}
            </Link>

            <span
              className={styles.breadcrumbSeparator}
              aria-hidden="true"
            >
              /
            </span>

            <span
              className={styles.breadcrumbCurrent}
              aria-current="page"
            >
              {post.title_post}
            </span>
          </nav>

          <div className={styles.categoryBadge}>
            <span className={styles.categoryIcon}>
              <img
                src={getDefaultIcon()}
                alt=""
                aria-hidden="true"
              />
            </span>

            <span className={styles.categoryText}>
              {getCategoryDisplayName()}
            </span>
          </div>

          <header className={styles.postHeader}>
            <h1 className={styles.postTitle}>
              {post.title_post}
            </h1>
          </header>

          <div className={styles.postMeta}>
            <div className={styles.metaItem}>
              <span className={styles.metaIcon}>
                <PremiumIcon type="date" />
              </span>

              <time
                dateTime={post.create_time_post}
                className={styles.metaText}
              >
                {formatDate(post.create_time_post)}
              </time>
            </div>

            {post.author_post && (
              <>
                <div
                  className={styles.metaSeparator}
                  aria-hidden="true"
                >
                  •
                </div>

                <div className={styles.metaItem}>
                  <span className={styles.metaIcon}>
                    <PremiumIcon type="author" />
                  </span>

                  <span className={styles.metaText}>
                    {post.author_post}
                  </span>
                </div>
              </>
            )}

            {post.original_time_post &&
              post.original_time_post !== post.create_time_post && (
                <>
                  <div
                    className={styles.metaSeparator}
                    aria-hidden="true"
                  >
                    •
                  </div>

                  <div className={styles.metaItem}>
                    <span className={styles.metaIcon}>
                      <PremiumIcon type="update" />
                    </span>

                    <time
                      dateTime={post.original_time_post}
                      className={styles.metaText}
                      title="تاریخ بروزرسانی"
                    >
                      {formatDate(post.original_time_post)}
                    </time>
                  </div>
                </>
              )}
          </div>

          <div className={styles.mediaSection}>
            {renderMedia()}
          </div>

          <div className={styles.postContent}>
            {post.html_post ? (
              <div
                className={styles.contentHtml}
                dangerouslySetInnerHTML={{
                  __html: post.html_post
                }}
              />
            ) : (
              <div className={styles.contentText}>
                {post.keywords_post ||
                  post.meta_description_post}
              </div>
            )}
          </div>

          <footer className={styles.postFooter}>
            <div
              className={`${styles.postStatus} ${
                post.status_post === 'published'
                  ? styles.statusPublished
                  : styles.statusPending
              }`}
            >
              <span className={styles.statusIcon}>
                <PremiumIcon
                  type={
                    post.status_post === 'published'
                      ? 'published'
                      : 'pending'
                  }
                  filled={
                    post.status_post === 'published'
                  }
                />
              </span>

              <span className={styles.statusText}>
                {post.status_post === 'published'
                  ? 'منتشر شده'
                  : 'در انتظار انتشار'}
              </span>
            </div>

            <div className={styles.navigationActions}>
              <Link
                to={`/${apiConfig.routePrefix}/${year}`}
                className={styles.backToListButton}
                title={`بازگشت به لیست ${getCategoryDisplayName()} سال ${year}`}
              >
                <PremiumIcon
                  type="back"
                  className={styles.backToListIcon}
                />

                <span>بازگشت به لیست</span>
              </Link>
            </div>
          </footer>
        </div>

        {renderRelatedPosts()}
      </article>
    </>
  );
}

// -------------------------------------------------------
// Arabic section
// -------------------------------------------------------

return (
  <>
    {commonHelmet}

    <article
      className={`${styles.postContainer} ${styles.isArabic}`}
      dir="rtl"
    >
      <div className={styles.postWrapper}>
        <nav
          className={styles.breadcrumb}
          aria-label="مسار الصفحة"
        >
          <Link
            to="/home"
            className={styles.breadcrumbLink}
          >
            الرئيسية
          </Link>

          <span
            className={styles.breadcrumbSeparator}
            aria-hidden="true"
          >
            /
          </span>

          <Link
            to={`/${apiConfig.routePrefix}`}
            className={styles.breadcrumbLink}
          >
            {getCategoryDisplayName()}
          </Link>

          <span
            className={styles.breadcrumbSeparator}
            aria-hidden="true"
          >
            /
          </span>

          <Link
            to={`/${apiConfig.routePrefix}/${year}`}
            className={styles.breadcrumbLink}
          >
            سنة {year}
          </Link>

          <span
            className={styles.breadcrumbSeparator}
            aria-hidden="true"
          >
            /
          </span>

          <span
            className={styles.breadcrumbCurrent}
            aria-current="page"
          >
            {post.title_post}
          </span>
        </nav>

        <div className={styles.categoryBadge}>
          <span className={styles.categoryIcon}>
            <img
              src={getDefaultIcon()}
              alt=""
              aria-hidden="true"
            />
          </span>

          <span className={styles.categoryText}>
            {getCategoryDisplayName()}
          </span>
        </div>

        <header className={styles.postHeader}>
          <h1 className={styles.postTitle}>
            {post.title_post}
          </h1>
        </header>

        <div className={styles.postMeta}>
          <div className={styles.metaItem}>
            <span className={styles.metaIcon}>
              <PremiumIcon type="date" />
            </span>

            <time
              dateTime={post.create_time_post}
              className={styles.metaText}
            >
              {formatDate(post.create_time_post)}
            </time>
          </div>

          {post.author_post && (
            <>
              <div
                className={styles.metaSeparator}
                aria-hidden="true"
              >
                •
              </div>

              <div className={styles.metaItem}>
                <span className={styles.metaIcon}>
                  <PremiumIcon type="author" />
                </span>

                <span className={styles.metaText}>
                  {post.author_post}
                </span>
              </div>
            </>
          )}

          {post.original_time_post &&
            post.original_time_post !== post.create_time_post && (
              <>
                <div
                  className={styles.metaSeparator}
                  aria-hidden="true"
                >
                  •
                </div>

                <div className={styles.metaItem}>
                  <span className={styles.metaIcon}>
                    <PremiumIcon type="update" />
                  </span>

                  <time
                    dateTime={post.original_time_post}
                    className={styles.metaText}
                    title="تاريخ التحديث"
                  >
                    {formatDate(post.original_time_post)}
                  </time>
                </div>
              </>
            )}
        </div>

        <div className={styles.mediaSection}>
          {renderMedia()}
        </div>

        <div className={styles.postContent}>
          {post.html_post ? (
            <div
              className={styles.contentHtml}
              dangerouslySetInnerHTML={{
                __html: post.html_post
              }}
            />
          ) : (
            <div className={styles.contentText}>
              {post.keywords_post ||
                post.meta_description_post}
            </div>
          )}
        </div>

        <footer className={styles.postFooter}>
          <div
            className={`${styles.postStatus} ${
              post.status_post === 'published'
                ? styles.statusPublished
                : styles.statusPending
            }`}
          >
            <span className={styles.statusIcon}>
              <PremiumIcon
                type={
                  post.status_post === 'published'
                    ? 'published'
                    : 'pending'
                }
                filled={
                  post.status_post === 'published'
                }
              />
            </span>

            <span className={styles.statusText}>
              {post.status_post === 'published'
                ? 'منشور'
                : 'منتظر النشر'}
            </span>
          </div>

          <div className={styles.navigationActions}>
            <Link
              to={`/${apiConfig.routePrefix}/${year}`}
              className={styles.backToListButton}
              title={`العودة إلى قائمة ${getCategoryDisplayName()} سنة ${year}`}
            >
              <PremiumIcon
                type="back"
                className={styles.backToListIcon}
              />

              <span>العودة إلى القائمة</span>
            </Link>
          </div>
        </footer>
      </div>

      {renderRelatedPosts()}
    </article>
  </>
);
};

export default Post;
